import { NavLink } from 'react-router-dom';

import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../../hook/useAppSelector';
import { SidebarMenu } from '../../../../enum/SidebarMenu';
import { useAppDispatch } from '../../../../hook/useAppDispatch';
import { setActiveSidebarElement } from '../../../../store/slice/config/config';

interface Props {
  label: string;
  path: string;
  icon: string;
  sidebarMenuType: SidebarMenu;
  handleClose?: () => void;
  testId: string;
}

const DirectNavLink: React.FC<Props> = ({ label, path, icon, sidebarMenuType, handleClose, testId }) => {
  const activeSidebarElement = useAppSelector((state) => state.configSlice.activeSidebarElement);
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  return (
    <NavLink to={path}>
      <div
        onClick={() => {
          dispatch(setActiveSidebarElement(sidebarMenuType));
          handleClose && handleClose();
        }}
        className={`sidebar_element_wrapper ${activeSidebarElement === sidebarMenuType ? 'active' : ''}`}
        data-pw={testId}
      >
        <span>
          <img src={icon} alt="icon"></img>
          <p className="title">{t(`${label}`)}</p>
        </span>
      </div>
    </NavLink>
  );
};

export default DirectNavLink;
